import { Navigate } from "react-router-dom";

// Legacy URL → unified /signin entry point. Kept so old bookmarks and email
// links keep working.
const Login = () => <Navigate to="/signin" replace />;

export default Login;